import BaseService from '@root/core/class/BaseService';

class buskService extends BaseService {
  public getWarehouseDetail = (id: any) => {
    return this.get(`/warehouses/${id}`);
  };
  public getSellerContactList = (id: string, page: number) => {
    return this.get(`/warehouses/${id}/sellers?page=${page}&limit=10`);
  };
  public getLogisticProductList = (id: string, page: number) => {
    return this.get(`/warehouses/${id}/products?page=${page}&limit=10`);
  };

  public postApproveWarehouseSignup = (id: string) => {
    return this.post(`/warehouses/${id}/approve`);
  };
  public postRejectWarehouseSignup = (id: string) => {
    return this.post(`/warehouses/${id}/reject`);
  };
  public postApproveWarehouseAmendment = (id: string) => {
    return this.post(`/warehouses/${id}/approveAmendment`);
  };
  public postRejectWarehouseAmendment = (id: string) => {
    return this.post(`/warehouses/${id}/rejectAmendment`);
  };
  public exportSellerContractExcell = (id: string) => {
    return this.post(
      `/warehouses/${id}/sellers/export`,
      {},
      {
        responseType: 'blob'
      }
    );
  };
  public exportSellerContractExcellById = (id: string, listId: any) => {
    return this.post(
      `/warehouses/${id}/sellers/export`,
      {
        ids: listId
      },
      {
        responseType: 'blob'
      }
    );
  };
  public exportWarehouseExcellProduct = (id: string) => {
    return this.post(
      `/warehouses/${id}/products/export`,
      {},
      {
        responseType: 'blob'
      }
    );
  };
  public exportWarehouseExcellProductById = (id: string, listId: any) => {
    return this.post(
      `/warehouses/${id}/products/export`,
      {
        ids: listId
      },
      {
        responseType: 'blob'
      }
    );
  };

  public getDeliveries = (id: string, page: number) => {
    return this.get(`/warehouses/${id}/deliveries?page=${page}&limit=10`);
  };

  public exportDeliveries = (id: string, listId?: any) => {
    return this.post(
      `/warehouses/${id}/deliveries/excel`,
      {
        ids: listId
      },
      {
        responseType: 'blob'
      }
    );
  };

  public getReturn = (id: string, page: number) => {
    return this.get(`/warehouses/${id}/returnDisposal?page=${page}&limit=10`);
  };

  public exportReturn = (id: string, listId?: any) => {
    return this.post(
      `/warehouses/${id}/returnDisposal/excel`,
      {
        ids: listId
      },
      {
        responseType: 'blob'
      }
    );
  };

  public getReturnProduct = (id: string, page: number) => {
    return this.get(`/warehouses/${id}/returnProduct?page=${page}&limit=10`);
  };

  public exportReturnProduct = (id: string, listId?: any) => {
    return this.post(
      `/warehouses/${id}/returnProduct/excel`,
      {
        ids: listId
      },
      {
        responseType: 'blob'
      }
    );
  };

  public exportAll = (id: string) => {
    return this.post(
      `/warehouses/${id}/excel-all`,
      {},
      {
        responseType: 'blob'
      }
    );
  };
}

export default new buskService('/api/v1/admin', true);
